export const INSCRIPTION_CREATE_RESET = "INSCRIPTION_CREATE_RESET";
export const INSCRIPTION_CREATE_SET_CREATED = "INSCRIPTION_CREATE_SET_CREATED";
export const INSCRIPTION_CREATE_SET_ERROR = "INSCRIPTION_CREATE_SET_ERROR";
export const INSCRIPTION_CREATE_SET_VIOLATIONS =
  "INSCRIPTION_CREATE_SET_VIOLATIONS";
export const INSCRIPTION_CREATE_TOGGLE_LOADING =
  "INSCRIPTION_CREATE_TOGGLE_LOADING";
export const INSCRIPTION_CREATE_SET_RETRIEVED =
  "INSCRIPTION_CREATE_SET_RETRIEVED";
